import React from "react";
import {useEffect, useState} from "react";

const Darkmode = () => {
  const [theme, setTheme] = useState("light-theme");
  const toggleTheme = () => {
    theme === "dark-theme" ? setTheme("light-theme") : setTheme("dark-theme");
  };

  useEffect(() => {
    document.body.className = theme;
  }, [theme]);

  return (
    <>
      <div className="DarkTheme">
        <a href="#" className="btn" onClick={() => toggleTheme()}>
        <i className="fa-solid fa-circle-half-stroke"></i>
        </a>
      </div>
    </>
  );
};

export default Darkmode;
